import { useTranslation } from 'react-i18next'

import { Button } from '#/shared/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '#/shared/ui/dialog'

interface UnsavedChangesDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  title?: string
  description?: string
  cancelLabel?: string
  confirmLabel?: string
}

export function UnsavedChangesDialog({
  open,
  onOpenChange,
  onConfirm,
  title,
  description,
  cancelLabel,
  confirmLabel,
}: UnsavedChangesDialogProps) {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <div className="flex flex-col gap-4 p-5">
          <div className="flex flex-col gap-1.5">
            <DialogTitle>{title ?? t('unsavedChanges.title')}</DialogTitle>
            <DialogDescription>
              {description ?? t('unsavedChanges.description')}
            </DialogDescription>
          </div>
          <div className="flex items-center justify-end gap-2.5">
            <Button
              type="button"
              variant="outline"
              size="xs"
              pressEffect
              className="px-3.5"
              onClick={() => onOpenChange(false)}
            >
              {cancelLabel ?? t('unsavedChanges.cancel')}
            </Button>
            <Button
              type="button"
              variant="destructive"
              size="xs"
              pressEffect
              className="px-3.5"
              onClick={onConfirm}
            >
              {confirmLabel ?? t('unsavedChanges.confirm')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
